/**
 * Copyright (C) 2018 Egylis,
 * Siège social, 46 rue René Clair, 75892 PARIS cedex 18 - France.
 * All Rights Reserved.
 *
 * E-mail : info@egylis.com
 *
 * This software is the confidential and proprietary information
 * of Egylis. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only
 * in accordance with the terms of the license agreement you
 * entered into with Egylis.
 *
 * Created by calvez on 07/12/18.
 *
 * Version : Generator 2.0.9
 */


/**
 * Column
 */
export interface MetaColumn {
    /**
     * Name.
     */
    name: string;
    /**
     * property Name.
     */
    propertyName?: string;
    /**
     * Column Type.
     */
    type: ColumnType;
    /**
     * Size
     */
    size?: number;
    /**
     * Is a primary Key
     */
    primaryKey?: boolean;
    /**
     * Is a index
     */
    index?: boolean;
}

/**
 * Column Type
 */
export enum ColumnType {
    UUID = 'UUID',
    STATUS = 'STATUS',
    TIMESTAMP = 'TIMESTAMP',
    DATETIME = 'DATETIME',
    DATE = 'DATE',
    STRING = 'STRING',
    INTEGER = 'INTEGER',
    FLOAT = 'FLOAT',
    BOOLEAN = 'BOOLEAN',
}
